import { updateProjectSelector, compressProjectForExportsSelector } from 'selectors'
import compressProject from 'helpers/projects/compressProject'
import compressCamera from 'helpers/projects/compressCamera'
import compressEntitiesForExports from 'helpers/exports/compressEntitiesForExports'
import { IMAGER_SIZES, CONVENTIONAL } from 'helpers/globals'
import resolutionLookup from 'helpers/cameras/resolutionLookup'
import fovModeHelper from 'helpers/fovModeHelper'
import accuracyMap from 'helpers/presentation/accuracyMap'
import checkForInfinityOrNaN from 'helpers/presentation/checkForInfinityOrNaN'
import evolve from 'ramda/src/evolve'
import chain from 'ramda/src/chain'
import sortItems from 'helpers/sortItems'
import uuid from 'uuid'
import getFocalLength from 'helpers/cameras/getFocalLength'
import { computeDistanceToBlindSpot } from 'components/BlindSpotPanelContainer/DowntiltDisplayContainer/helpers'
import computeFriendlyTilt from 'helpers/cameras/computeFriendlyTilt'

const parseAndRound = key => num => checkForInfinityOrNaN(num) ? 0 : parseFloat(num).toFixed(accuracyMap().get(key))

function gatherExportPresentationValues(camera) {
  const { fovMode, focalLength, ppf, distance, imagerSize, horizontalResolution, verticalResolution, model,
    cameraHeight, tilt, sceneHeight, verticalAngleOfView, horizontalAngleOfView, location,
    wireDistance, networkClosetName } = camera

  const values = {
    angleOfView: camera[`${fovModeHelper(fovMode)}AngleOfView`],
    fieldOfView: camera[`${fovModeHelper(fovMode)}FieldOfView`],
    imagerSize: IMAGER_SIZES.find(i => i.value === imagerSize).text,
    resolution: resolutionLookup({ horizontalResolution, verticalResolution, model }),
    manufacturer: model ? model.manufacturer : null,
    model: model ? model.model : null,
    focalLength: getFocalLength({ model, focalLength: parseAndRound('focalLength')(focalLength) }),
    ppf,
    distance,
    cameraHeight,
    tilt: computeFriendlyTilt({ tilt, horizontalAngleOfView, verticalAngleOfView, fovMode }),
    sceneHeight,
    distanceToBlindSpot: computeDistanceToBlindSpot(tilt, fovMode === CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView, cameraHeight),
    location,
    wireDistance: wireDistance || null,
    networkClosetName: networkClosetName || null
  }

  const evolveValues = {
    ppf: parseAndRound('ppf'),
    angleOfView: parseAndRound('angleOfView'),
    distance: parseAndRound('distance'),
    fieldOfView: parseAndRound('fieldOfView'),
    cameraHeight: parseAndRound('cameraHeight'),
    sceneHeight: parseAndRound('sceneHeight'),
    distanceToBlindSpot: parseAndRound('distance')
  }

  return { exportPresentationValues: evolve(evolveValues, values) }
}

function prepareCamera(camera, isCsv) {
  return Object.assign(
    {},
    compressCamera(camera),
    isCsv && gatherExportPresentationValues(camera)
  )
}

const prepareMultiImager = (camera, cameras, isCsv) => {
  const { name, lensIds } = camera

  const lenses = lensIds.map(lensId => {
    const lens = cameras.find(c => c.id === lensId)
    return { ...prepareCamera(lens, isCsv), name: name + ': ' + lens.name }
  })

  return [ Object.assign({}, compressCamera(camera)), ...sortItems(lenses) ]
}

export default function(state, isCsv) {
  const { cameras } = compressProjectForExportsSelector(state, isCsv)
  const sortedCameras = sortItems(cameras.filter(c => !c.imagerId))

  return {
    project: Object.assign(
      {},
      compressProject(updateProjectSelector(state)),
      {
        cameras: chain(c => c.isMultiImager ? prepareMultiImager(c, cameras, isCsv) : prepareCamera(c, isCsv), sortedCameras),
        exportId: uuid.v4(),
        cameraDataFilename: state.cameraDataFilename,
        userSettings: state.userSettings
      },
      isCsv && { entities: compressEntitiesForExports(state) }
    )
  }
}



// WEBPACK FOOTER //
// ./src/helpers/exports/compressProjectForExports.js